function GameJam() {
    return (<div>
        In preparation for the 3rd year group project, my friends and I competed in a Game Jam. The theme was "It's not a bug it's a feature" and we created a small puzzle game. For a lot of the team it was the first time using Unity and so the game was very rough with some <i>interesting</i> design choices. Each puzzle could be solved using a common computer game bug (integer overflow, camera clipping, faulty level reset, etc...). We ended up winning the "Best Plot Twist" category and learnt a lot of the basics of Unity.
    </div>);
}

export default GameJam;